import useSWRMutation from 'swr/mutation';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { PostUploadFile, useGet } from '@ngt/forms';
import { client } from '../api/client';
import { GetLabelFileUploadAsync, GetLabelFileUploadAsyncResponse, IFormFile, PostLabelUploadAsync } from '../api/dtos';

async function uploadFetcher(_key: string, { arg }: { arg: IFormFile }) {

    const formData = new FormData();
    formData.append('File', arg as unknown as Blob, arg.name);

    return await client.apiForm(new PostLabelUploadAsync(), formData);
}

const getData = (response?: SWRResponse<GetLabelFileUploadAsyncResponse, GetLabelFileUploadAsyncResponse>) => response?.data;

const getError = (response?: SWRResponse<GetLabelFileUploadAsyncResponse, GetLabelFileUploadAsyncResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetLabelFileUploadAsyncResponse, GetLabelFileUploadAsyncResponse>) => ({
    file: response?.data
});

export const useGetFileUpload = (configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return () => new GetLabelFileUploadAsync();
    }, []);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export const useFileUpload = () => {
    const { trigger, data, error, isMutating } = useSWRMutation(
        'PostLabelUploadAsync', 
        uploadFetcher
    );

    return {
        upload: trigger, 
        data,
        error,
        isLoading: isMutating
    };
};

export default useFileUpload;